import styled from "styled-components";
import { Colors } from "../theme";

function DeleteAccount() {
  return (
    <Container>
      <Title>Delete Your Bite Account</Title>

      <Section>
        <SectionTitle>In the App</SectionTitle>
        <List>
          <ListItem>1. Open Bite on your device.</ListItem>
          <ListItem>2. Go to Settings → Account.</ListItem>
          <ListItem>3. Tap “Delete Account” and confirm.</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>No Longer Have the App?</SectionTitle>
        <List>
          <ListItem>
            Email us at{" "}
            <a href="mailto:support@biterecipes.co">
              support@biterecipes.co
            </a>{" "}
            and include:
          </ListItem>
          <ListItem>- The email address associated with your account</ListItem>
          <ListItem>- A request to delete your account</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>Data Deletion Information</SectionTitle>
        <List>
          <ListItem>
            <strong>Data that will be deleted:</strong>
          </ListItem>
          <ListItem>- Your profile information</ListItem>
          <ListItem>- Your activity history</ListItem>
          <ListItem>- Your uploaded content</ListItem>
          {/* <ListItem>- [Any other relevant data types]</ListItem> */}

          <ListItem>
            <strong>Data retention:</strong>
          </ListItem>
          <ListItem>
            - We will process your deletion request within 30 days
          </ListItem>
          <ListItem>
            - Some information may be retained for legal compliance
          </ListItem>
          <ListItem>- Anonymized analytics data may be retained</ListItem>
        </List>
      </Section>

      <Section>
        <p>
          If you have any questions about the account deletion process, please
          contact our support team at{" "}
          <a href="mailto:support@biterecipes.co">
            support@biterecipes.co
          </a>
        </p>
      </Section>
    </Container>
  );
}

export default DeleteAccount;

const Container = styled.div`
  // max-width: 800px;
  margin: 0 auto;
  padding: 0 60px 30px;
  // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

const Title = styled.h1`
  color: #333;
  margin-bottom: 2rem;
`;

const Section = styled.section`
  margin-bottom: 2rem;
  a {
    color: ${Colors.primary};
  }
`;

const SectionTitle = styled.h2`
  color: #444;
  margin-bottom: 1rem;
`;

const List = styled.div`
  // margin-left: 1.5rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.div`
  margin-bottom: 0.5rem;
  line-height: 1.6;
`;
